import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { LogoFull } from "../../assets/icons/logoFull";
import { LocaleLink } from "../Language/LocaleLink";
import { stripLocalePrefix } from "../../utils/localePaths";

export const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { basePath } = stripLocalePrefix(location.pathname);
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);

  const toggleOffcanvas = () => {
    setIsOffcanvasOpen(!isOffcanvasOpen);
  };

  const closeOffcanvas = () => {
    setIsOffcanvasOpen(false);
  };

  return (
    <header className="header my-4">
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light py-2">
          <div className="d-flex justify-content-between align-items-center w-100">
            <LocaleLink
              to="/"
              className="d-flex align-items-center me-md-auto link-body-emphasis text-decoration-none"
              aria-label="onBookmarks"
            >
              <LogoFull width="180" height="40" />
            </LocaleLink>
            <button
              className="navbar-toggler"
              type="button"
              onClick={toggleOffcanvas}
              aria-controls="offcanvasNavbar"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <div className="d-flex gap-2 ms-auto align-items-center">
                <ul className="navbar-nav me-2">
                  <li className="nav-item mx-1">
                    <LocaleLink
                      className={`nav-link ${
                        basePath === "/" ? "active" : "alink"
                      }`}
                      to="/"
                    >
                      {t("header.home")}
                    </LocaleLink>
                  </li>
                  <li className="nav-item mx-1">
                    <LocaleLink
                      className={`nav-link ${
                        basePath === "/features" ? "active" : "alink"
                      }`}
                      to="/features"
                    >
                      {t("header.features")}
                    </LocaleLink>
                  </li>
                  <li className="nav-item mx-1">
                    <LocaleLink
                      className={`nav-link ${
                        basePath === "/pricing" ? "active" : "alink"
                      }`}
                      to="/pricing"
                    >
                      {t("header.pricing")}
                    </LocaleLink>
                  </li>
                  <li className="nav-item mx-1">
                    <LocaleLink
                      className={`nav-link ${
                        basePath === "/directory" ? "active" : "alink"
                      }`}
                      to="/directory"
                    >
                      {t("header.directory")}
                    </LocaleLink>
                  </li>
                </ul>
                <Link
                  to={`${process.env.REACT_APP_APP_URL}/signin`}
                  className="btn btn-link text-muted text-decoration-none px-3"
                >
                  {t("header.signin")}
                </Link>
                <Link
                  to={`${process.env.REACT_APP_APP_URL}/register`}
                  className="btn btn-primary rounded-pill px-4"
                >
                  {t("header.signup")}
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </div>

      <div
        className={`offcanvas offcanvas-end ${isOffcanvasOpen ? "show" : ""}`}
        tabIndex="-1"
        id="offcanvasNavbar"
        aria-labelledby="offcanvasNavbarLabel"
        style={{ visibility: isOffcanvasOpen ? "visible" : "hidden" }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
            <LogoFull width="150" height="35" />
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeOffcanvas}
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
            <li className="nav-item">
              <LocaleLink
                className={`nav-link ${basePath === "/" ? "active" : ""}`}
                to="/"
                onClick={closeOffcanvas}
              >
                {t("header.home")}
              </LocaleLink>
            </li>
            <li className="nav-item">
              <LocaleLink
                className={`nav-link ${
                  basePath === "/features" ? "active" : ""
                }`}
                to="/features"
                onClick={closeOffcanvas}
              >
                {t("header.features")}
              </LocaleLink>
            </li>
            <li className="nav-item">
              <LocaleLink
                className={`nav-link ${
                  basePath === "/pricing" ? "active" : ""
                }`}
                to="/pricing"
                onClick={closeOffcanvas}
              >
                {t("header.pricing")}
              </LocaleLink>
            </li>
            <li className="nav-item">
              <LocaleLink
                className={`nav-link ${
                  basePath === "/directory" ? "active" : ""
                }`}
                to="/directory"
                onClick={closeOffcanvas}
              >
                {t("header.directory")}
              </LocaleLink>
            </li>
          </ul>
          <div className="d-grid gap-3 mt-2">
            <Link
              to={`${process.env.REACT_APP_APP_URL}/signin`}
              className="btn btn-light p-2"
              onClick={closeOffcanvas}
            >
              {t("header.signin")}
            </Link>
            <Link
              to={`${process.env.REACT_APP_APP_URL}/register`}
              className="btn btn-primary p-2"
              onClick={closeOffcanvas}
            >
              {t("header.signup")}
            </Link>
          </div>
        </div>
      </div>

      {isOffcanvasOpen && (
        <div
          className="offcanvas-backdrop fade show"
          onClick={closeOffcanvas}
        ></div>
      )}
    </header>
  );
};
